import { useEffect, useState } from 'react';
import { Form, Input, Select, Switch, Divider, Row, Col, Tag } from 'antd';

import './style.scss';

const curlyBracedRegexp = /@(.*?)/g;

const TargetSettingsPanel = ({
  userProperties: defaultUserProperties,
  form,
  segments,
}) => {
  const [userProperties, setUserProperties] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(
    () => setUserProperties(defaultUserProperties),
    [defaultUserProperties]
  );

  useEffect(() => {
    form.resetFields(['user_properties', 'user_properties_input']);

    let filteredUserProperties = [...defaultUserProperties];

    tags.forEach((tag) => {
      const value = Object.keys(tag)[0];
      if (defaultUserProperties.find((prop) => prop.value === value)) {
        filteredUserProperties = filteredUserProperties.filter(
          (prop) => prop.value !== value
        );
      }
    });

    setUserProperties(filteredUserProperties);

    const userPropertyData = {};

    tags.forEach((item) => {
      let key = Object.keys(item)[0];
      let value = item[key];
      userPropertyData[
        key.replace(curlyBracedRegexp, (_, capturedContent) => capturedContent)
      ] = value;
    });

    form.setFieldValue('userPropertyData', userPropertyData);
  }, [tags]);

  const onUserPropAdd = (e) => {
    e.preventDefault();
    const { value } = e.target;
    const fieldValue = form.getFieldValue('user_properties');

    if (!value.trim() || !fieldValue) {
      return;
    }

    setTags([
      ...tags,
      {
        [fieldValue]: value,
      },
    ]);
  };

  const onTagRemoved = (tag) => {
    const filteredTags = tags.filter(
      (t) => Object.keys(t)[0] !== Object.keys(tag)[0]
    );

    setTags(filteredTags);
  };

  return (
    <div className="target-settings-panel">
      <Form.Item
        label="Labels"
        name="segments"
        // extra="You can select desired labels from your label list by clicking on them."
      >
        <Select
          size="large"
          mode="tags"
          style={{
            width: '100%',
          }}
          placeholder="Add or Select Labels"
          options={segments
            ?.split(',')
            .filter(Boolean)
            .map((segment) => {
              return { label: segment, value: segment, key: segment };
            })}
        />
      </Form.Item>
      <Form.Item
        label="Custom Parameter"
        name="customParameter"
        // extra="You can type the parameter to see how your personalized content will look."
      >
        <Input size="large" placeholder="Enter your custom parameter" />
      </Form.Item>
      <Form.Item label="Locale" name="locale">
        <Input size="large" placeholder="Select Language" />
      </Form.Item>
      <div className="target-settings-panel-user-props">
        <h6>User Property</h6>
        <div className="target-settings-panel-user-props-inputs">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Property Name" name="user_properties">
                <Select
                  showSearch
                  size="large"
                  placeholder="Select User Prop."
                  options={userProperties}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item noStyle dependencies={['user_properties']}>
                {({ getFieldValue }) => {
                  return (
                    <Form.Item
                      label="Property Value"
                      name="user_properties_input"
                      validateTrigger="onPressEnter"
                      rules={[
                        {
                          type: 'string',
                          required: !!getFieldValue('user_properties'),
                          whitespace: true,
                          message: 'Fill the property value and hit Enter',
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        placeholder="e.g. Emma"
                        onPressEnter={onUserPropAdd}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
            <Col span={24}>
              <div className="target-settings-panel-user-props-tags">
                {tags.map((tag) => (
                  <Tag
                    onClose={() => onTagRemoved(tag)}
                    closeIcon
                    key={Object.keys(tag)[0]}
                  >{`${Object.keys(tag)[0].replace(
                    curlyBracedRegexp,
                    (_, capturedContent) => capturedContent
                  )} = ${Object.values(tag)[0]}`}</Tag>
                ))}
                <Form.Item hidden name="userPropertyData">
                  <Input />
                </Form.Item>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Row justify="space-between" style={{ marginBottom: 24 }}>
        <Col span={12}>
          <h6>Show Test Groups</h6>
        </Col>
        <Col>
          <Form.Item noStyle name="isTestMode" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default TargetSettingsPanel;
